import { Extension, ReaderContext, WriterContext } from '@gltf-transform/core3';
import { CYNCLY_MATERIALS_METADATA } from '../constants';
import { MaterialMetadata } from './material-metadata';

const NAME = CYNCLY_MATERIALS_METADATA;

interface MaterialMetadataDef {
	mCode: string | null;
}

export class CYNCLYMaterialsMetadata extends Extension {
	public readonly extensionName = NAME;
	public static readonly EXTENSION_NAME = NAME;

	/** Creates a new MaterialMetadata property for use on a {@link Material}. */
	public createMaterialMetadata(name = ''): MaterialMetadata {
		return new MaterialMetadata(this.document.getGraph(), name);
	}

	public read(context: ReaderContext): this {
		const jsonDoc = context.jsonDoc;

		jsonDoc.json.materials!.forEach((materialDef, materialIndex) => {
			if (!materialDef.extensions || !materialDef.extensions[NAME]) return;
			const materialMetadataDef = materialDef.extensions[NAME] as MaterialMetadataDef;
			const materialMetadata = this.createMaterialMetadata()
			
			materialMetadata.setMCode(materialMetadataDef.mCode);

			context.materials[materialIndex].setExtension(NAME, materialMetadata);
		});

		return this;
	}

	public write(context: WriterContext): this {
		if (this.properties.size === 0) return this;

		this.document
			.getRoot()
			.listMaterials()
			.forEach((material) => {
				const materialMetadata = material.getExtension<MaterialMetadata>(NAME);
				if (materialMetadata) {
					const materialMetadataDef = {} as MaterialMetadataDef;

					if (materialMetadata.getMCode() != null) {
						materialMetadataDef.mCode = materialMetadata.getMCode()
					}

					const materialIndex = context.materialIndexMap.get(material)!;
					const materialDef = context.jsonDoc.json.materials![materialIndex];
					materialDef.extensions = materialDef.extensions || {};
					materialDef.extensions[NAME] = materialMetadataDef;
				}
			});

		return this;
	}
}
